import axios from 'axios'

import { Store } from 'vuex';
const API_URL = "http://supportsoft.in/pizza/api";

const state = { 
   selectedItems: { } ,
   orders: [],
   toppings: [],
   sub_total: '0.00',
   delivery_amount: '0.00',
   total_amount: '0.00',
   order_id: null,
   cartAdded: false,
   deleveryType: '',
   d_checked: false,
   p_checked: false,
   currentCartMenu: 'ass',
   deliverBox: false,
   orderPlaced: false,
   myOrders: [],
   default_toppings: [],
   extra_toppings: []
 };
const actions = { 
    
    async setMenuItem({commit}, payload){
        let user_key = sessionStorage.getItem('user_key')
        let url = API_URL+'/add-menu-item'
        let data = { "user_key" : user_key, "menu_slug" : payload.menu_slug, "defaultToppings": payload.defaultToppings}
        let access_token = sessionStorage.getItem('access_token');
        await axios.post(url, data, { headers: { Authorization: "Bearer " + access_token }}).then(response => {
          // console.log(" Server Response added menu")
        }).catch(err => {
          console.log(" Server error " + err)  
        })
    },
    async addMenus({commit}, payload){
      let url = API_URL+'/add-menu-item-details'
      let access_token = sessionStorage.getItem('access_token');
      await axios.post(url, payload, { headers: { Authorization: "Bearer " + access_token }}).then(response => {
        // console.log(" Server Response " + response.data.message)
      }).catch(err => {
        console.log(" Server error " + err)  
      })
    },
    async addToppings({commit}, payload){
      let url = API_URL+'/add-toppings';
      let access_token = sessionStorage.getItem('access_token');
      await axios.post(url, payload, { headers: { Authorization: "Bearer " + access_token }}).then(response => {
        console.log(" Server Response " + response.data.message)
      }).catch(err => {
        console.log(" Server error " + err)  
      })
    },
    async removeToppings({commit}, payload){
      let url = API_URL+'/delete-toppings';
      let access_token = sessionStorage.getItem('access_token');
      await axios.post(url, payload, { headers: { Authorization: "Bearer " + access_token }}).then(response => {
        console.log(" Server Response " + response.data.message)
      }).catch(err => {
        console.log(" Server error " + err)  
      })
    },
    async updateAddedToppings({commit}, payload){
      let url = API_URL+'/update-toppings';
      let access_token = sessionStorage.getItem('access_token');
      await axios.post(url, payload, { headers: { Authorization: "Bearer " + access_token }}).then(response => {
        console.log(" Server Response " + response.data.message)
      }).catch(err => {
        console.log(" Server error " + err)  
      })
    },
    addDefaultToppings({commit}, payload){
      return new Promise( (resolve, reject) => {
        let url = API_URL+'/add-default-toppings';
        let access_token = sessionStorage.getItem('access_token');
        axios.post(url, payload, { headers: { Authorization: "Bearer " + access_token }}).then(response => {
          // console.log(" Server Response " + response.data.message)
          resolve(response.data)
        }).catch(err => {
          console.log(" Server error " + err)  
          reject(err)
        })
      });
    },
    addDefaultFlavour({commit}, payload){
      return new Promise( (resolve, reject) => {
        let url = API_URL+'/add-default-flavour';
        let access_token = sessionStorage.getItem('access_token');
        axios.post(url, payload, { headers: { Authorization: "Bearer " + access_token }}).then(response => {
          // console.log(" Server Response " + response.data.message)
          resolve(response.data)
        }).catch(err => {
          console.log(" Server error " + err)  
          reject(err)
        })
      });
    },
    removeDefaultToppings({commit}, payload){
      return new Promise( (resolve, reject) => {
        let url = API_URL+'/delete-default-toppings';
        let access_token = sessionStorage.getItem('access_token');
        axios.post(url, payload, { headers: { Authorization: "Bearer " + access_token }}).then(response => {
          // console.log(" Server Response " + response.data.message)
          resolve(response.data.message)
        }).catch(err => {
          console.log(" Server error " + err)  
          reject(err)
        })
      })
    },
    deleteVarieties({commit}, payload){
      return new Promise( (resolve, reject) => {
        let url = API_URL+'/delete-varieties';
        let access_token = sessionStorage.getItem('access_token');
        axios.post(url, payload, { headers: { Authorization: "Bearer " + access_token }}).then(response => {
          // console.log(" Server Response " + response.data.message)
          resolve(response.data.message)
        }).catch(err => {
          // console.log(" Server error " + err)  
          reject(err)
        })
      })
    },
    addOrder({commit}, payload){
      return new Promise((resolve, reject) => {
        let url = API_URL+'/add-order';
        let access_token = sessionStorage.getItem('access_token');
        axios.post(url, payload, { headers: { Authorization: "Bearer " + access_token }}).then(response => {
            let order_total = response.data.orderTotal
            let orders = response.data.orders
            commit('addOrder', orders)
            commit('orderTotal', order_total)
            this.dispatch('getDefaultToppings',payload.menu_id)
            this.dispatch('getExtraToppings',payload.menu_id)
            commit('updateCartAdded','update')
            resolve(orders,order_total)
        }).catch(err => {
          console.log("Error "+err)
          reject(err)
        })
      })
    },
    cancelOrder({commit}, payload){
      return new Promise( (resolve, reject) => {
        let url = API_URL+'/cancel-order';
        axios.post(url, payload).then(response => {
            commit('emptyCart')
            resolve(response)
        }).catch(err => {
          console.log("Error "+err)
          reject(err)
        })
      })
    },
    userDeliveryAddress({commit},payload){
      return new Promise( (resolve, reject) => {
        let url = API_URL+'/getDeliveryAddress';
          axios.post(url, payload).then(response => {
            resolve(response);
          }).catch(err => {
            console.log("Error " + err)
            reject();
          })
      });
    },
    getDefaultToppings({commit}, payload) {
      return new Promise( (resolve, reject) => {
        let menu_id = payload
        let url = API_URL+ '/default-toppings?menu_id='+menu_id;
        axios.get(url).then(response => {
        let catData = response.data
          commit('updateDefaultList', catData)
          resolve(catData);
          }).catch(err => {
              console.log(err);
              reject(err);
          });   
      })
      
    },
    getExtraToppings({commit}, payload) {
      return new Promise((resolve, reject) => {
        let menu_id = payload
        let url = API_URL+ '/extra-toppings?menu_id='+menu_id;
        axios.get(url).then(response => {
          let catData = response.data
          commit('updateExtraList', catData)
          resolve(catData)
          }).catch(err => {
              console.log(err);
              reject(err);
          }); 
      })
        
    },
    getCartItem({commit}){
      return new Promise((resolve, reject) => {
        let user_key = sessionStorage.getItem('user_key')
        let access_token = sessionStorage.getItem('access_token')
        let url = API_URL+'/get-cart?user_key='+user_key
        axios.get(url,{ headers: { Authorization: "Bearer " + access_token }}).then(response => {
          let cartCount = response.data.orderTotal
          cartCount =  Object.keys(cartCount).length
          if(cartCount > 0){
            let order_total = response.data.orderTotal
            let orders = response.data.orders
            if(orders.length === 0){
              commit('emptyCart');
            }else{
              commit('updateCartAdded','update')
              commit('addOrder', orders)
              commit('orderTotal', order_total)
            }
            resolve(orders,order_total)
          }
        }).catch(err => {
          console.log("Error Found " + err)
          reject(err)
        })
      })
      
    },
    updateDeliveryType({commit}, payload){
      return new Promise( (resolve, reject) => {
          let user_key = sessionStorage.getItem('user_key')
          let url = API_URL+'/update-delivery';
          let access_token = sessionStorage.getItem('access_token');
          let data = { "user_key": user_key, "deliveryType": payload }
          axios.post(url, data, { headers: { Authorization: "Bearer " + access_token }}).then(response => {
            let order_total = response.data.orderTotal
            let orders = response.data.orders
            commit('updateCartAdded','update')
            commit('addOrder', orders)
            commit('orderTotal', order_total)
            resolve(order_total)
          }).catch(err => {
            reject(err)
          })
      })
    },
    deleteOrderMenuItem({commit}, payload){
      return new Promise((resolve, reject) => {
          let url = API_URL+'/delete-order-menu-item';
          let access_token = sessionStorage.getItem('access_token');

          axios.post(url, payload, { headers: { Authorization: "Bearer " + access_token }}).then(response => {
            let orders = response.data.orders
            let order_total = response.data.orderTotal
            commit('addOrder', orders)
            commit('orderTotal', order_total)
            commit('updateCartAdded','update')
            resolve(orders,order_total);
            
          }).catch(err => {
            console.log("Error " + err);
            reject(err);
          });  
      });
    },
    placeOrder({commit}, payload){
      return new Promise( (resolve, reject) => {
        let url = API_URL+'/placeOrder';
        let access_token = sessionStorage.getItem('access_token');
        axios.post(url, payload, { headers: { Authorization: "Bearer " + access_token }}).then(response => {
          commit("orderPlaced");          
          resolve(response.data);
        }).catch(err => {
          console.log("Error " + err)
          reject();
        })
      });
      
    },
    getMyOrders({commit}){
      return new Promise((resolve, reject)=> {
        let url = API_URL+'/myOrder';
        let access_token = sessionStorage.getItem('access_token');
        axios.get(url, { headers: { Authorization: "Bearer " + access_token }}).then(response => {
          let myOrders = response.data.orders
          commit("myOrders", myOrders)
          resolve(myOrders)
        }).catch(err => {
          console.log("Error " + err)
          reject(err)
        })
      })
      
    },
    myOrderDetails({commit}, payload){
      return new Promise( (resolve, reject) => {
        let url = API_URL+'/myOrderDetails';
        let access_token = sessionStorage.getItem('access_token');
        axios.post(url, payload,{ headers: { Authorization: "Bearer " + access_token }}).then(response => {
          resolve(response.data.orders)
        }).catch(err => {
          console.log("Error " + err)
          reject(err)
        })
      });
    }
    
};
const mutations = { 
  setmenuItems:(state, payload) => {
    state.selectedItems[payload] = [];
  },
  setItems: (state, payload) => {
    let str = {"menuItems":payload,"menuToppings" : {},"defaultToppings":{}};
    state.selectedItems[payload.menuName].push(str)
  },
  setToppings: (state, payload) => {

    let str = {"etopp_id": payload.etopp_id,"etopp_name": payload.etopp_name,"etopp_qty": payload.etopp_qty , "etopp_price" : payload.etopp_price};
    state.selectedItems[payload.menuName]['menuToppings'][payload.etopp_id] = str
  },
  removeToppings: (state, payload) => {
    delete state.selectedItems[payload.menuName]['menuToppings'][payload.etopp_id]
  },
  updateAddedToppings: (state, payload) => {
    let str = {"etopp_id": payload.etopp_id,"etopp_name": payload.etopp_name,"etopp_qty": payload.etopp_qty , "etopp_price" : payload.etopp_price};
    state.selectedItems[payload.menuName]['menuToppings'][payload.etopp_id] = str;
  },
  setDefaultToppings: (state, payload) => {
    let str = {"etopp_id": payload.etopp_id,"etopp_name": payload.etopp_name,"etopp_qty": payload.etopp_qty , "etopp_price" : payload.etopp_price};
    state.selectedItems[payload.menuName]['defaultToppings'][payload.etopp_id] = str
  },
  removeDefaultToppings: (state, payload) => {
    delete state.selectedItems[payload.menuName]['defaultToppings'][payload.etopp_id]
  },
  cartToppings:(state, payload) => {
    state.selectedItems = payload
  },
  updateToppings: (state, payload) => {
    state.currentCartMenu = Object.keys(payload)
    let toppingsItems = Object.values(payload);
    $.each(toppingsItems, (index, value) => {
      $.each(value, (ind, val) => {
        state.selectedItems[Object.keys(payload)][ind] = val
      })
    })
  
  },
  updatePizzaTotal: (state, payload) => {
    let totalPizzaPrice = payload.pizza_total
    state.selectedItems[payload.menuName].menuItems.price = totalPizzaPrice
  },
  addComment(state,payload){
    state.selectedItems[payload.menuName].menuItems.comments = payload.comments
  },
  updateCartAdded(state, payload){
    if(state.orders.length > 0){
      state.cartAdded = true
    }else{
      state.cartAdded = false
    }
  },
  emptyCart(state){
    // console.log("called")
    state.cartAdded = false
  },
  addOrder(state, payload){
    // state.orders = [];
    state.orders = payload;
    if(state.orders){
      state.cartAdded = true
    }else{
      state.cartAdded = false;
    }
  },
  orderPlaced(state){
    state.orderPlaced = true;
    state.cartAdded = false;
  },
  myOrders(state, payload){
    state.myOrders.push(payload)
  },
  orderTotal(state, payload){
    setTimeout(() => {
      state.order_id = payload.id
      state.sub_total = payload.sub_total;
      state.delivery_amount = payload.delivery_amount;
      state.total_amount = payload.total_amount;
      state.deleveryType = payload.delivery_type;
      if(payload.delivery_type === 'delivery'){
        state.d_checked = true;
        state.p_checked = false;
        state.deliverBox = true;
      }else{
        state.p_checked = true;
        state.d_checked = false;
        state.deliverBox = false;
      }
    },500)
  },
  updateDefaultList: (store, payload) => {
      store.default_toppings = payload
  },
  updateExtraList: (store, payload) => {
      store.extra_toppings = payload
  }
};
const getters = { 
    orders: (state) => state.orders,
    order_id: (state) => state.order_id,
    sub_total: (state) => state.sub_total,
    delivery_amount: (state) => state.delivery_amount,
    total_amount: (state) => state.total_amount,
    cartAdded: (state) => state.cartAdded,
    deleveryType: (state) => state.deleveryType,
    d_checked: (state) => state.d_checked,
    p_checked: (state) => state.p_checked,
    deliverBox: (state) => state.deliverBox,
    orderPlaced: (state) => state.orderPlaced,
    myOrders: (state) => state.myOrders,
    extraToppings: (state) => state.extra_toppings,
    defaultToppings: (state) => state.default_toppings,
};
export default {
    state,
    actions,
    mutations,
    getters
};